module.exports = __webpack_public_path__ + "img/aviation_system2_m.4030ed9e.png";